/**
 * Excel de la lista de Asignación de Turnos.
 *
 * Es un reporte para leer, con el estilo de `ExcelTablaReporte`; no es la
 * plantilla del importador (esa trae ID codificado y se vuelve a subir).
 *
 * Sin React ni axios a propósito: así se puede revisar con un `node script.js`.
 */

import moment from "moment";
import {
  centro,
  construirHojaTabla,
  descargarLibro,
  fechaMexico,
  identificador,
  texto,
} from "../../../Components/ExcelTablaReporte";
import {
  ESTADO_NOMBRE,
  claveSerieNumero,
  nombreEmpleado,
} from "../../../Components/importarAsignaciones.utils";
import { etiquetaTurno } from "./ImportarAsignacionTurnos/plantillaAsignacionTurnos";

const TITULO = "Asignación de Turnos";

const COLUMNAS = [
  { titulo: "Número", tipo: "identificador", ancho: 12 },
  { titulo: "Código Empleado", tipo: "identificador", ancho: 12 },
  { titulo: "Número Empleado", tipo: "identificador", ancho: 14 },
  { titulo: "Empleado", tipo: "texto", ancho: 34 },
  { titulo: "Departamento", tipo: "texto", ancho: 24 },
  { titulo: "Puesto", tipo: "texto", ancho: 24 },
  { titulo: "Turno", tipo: "texto", ancho: 34 },
  { titulo: "Inicio", tipo: "fecha", ancho: 13 },
  { titulo: "Fin", tipo: "fecha", ancho: 13 },
  { titulo: "Estado", tipo: "centro", ancho: 14 },
  { titulo: "Fecha de alta", tipo: "fecha", ancho: 13 },
];

// Mismas opciones del segmentado de la pantalla.
const ESTADO_FILTRO = { 1: "Vigentes", 2: "Deshabilitadas", 3: "Todas" };

const hayFiltrosDeColumna = (filters) =>
  Object.values(filters || {}).some((valor) =>
    Array.isArray(valor) ? valor.length > 0 : valor !== undefined && valor !== null && valor !== "",
  );

const codigoEmpleado = (empleado) =>
  empleado?.codigo === undefined || empleado?.codigo === null
    ? ""
    : String(empleado.codigo).padStart(4, "0");

/** `{ columnas, filas, totales }` a partir de lo que regresa exportarAsignacionesTurnos. */
export const construirTablaAsignaciones = (asignaciones) => ({
  columnas: COLUMNAS,
  filas: (asignaciones || []).map((asignacion) => [
    identificador(claveSerieNumero(asignacion)),
    identificador(codigoEmpleado(asignacion.empleado)),
    identificador(claveSerieNumero(asignacion.empleado)),
    texto(nombreEmpleado(asignacion.empleado)),
    texto(asignacion.departamentoNombre),
    texto(asignacion.puestoNombre),
    texto(etiquetaTurno(asignacion.turno)),
    // Inicio y fin son días, pero se guardan con hora (mediodía UTC las del
    // Excel y "Agregar Varias", la hora del navegador las de una en una). El día
    // en hora de México es el que usan los reportes de asistencia.
    fechaMexico(asignacion.inicio),
    fechaMexico(asignacion.fin),
    centro(ESTADO_NOMBRE[Number(asignacion.estado)] || ""),
    fechaMexico(asignacion.createdAt),
  ]),
  totales: [],
});

export const exportarAsignacionesTurnos = ({ asignaciones, empresaNombre, valor, filters }) => {
  const descripcionFiltros = [
    `Estado: ${ESTADO_FILTRO[valor] || "Todas"}`,
    hayFiltrosDeColumna(filters) ? "con filtros de búsqueda" : null,
  ]
    .filter(Boolean)
    .join(" · ");

  const hoja = construirHojaTabla(construirTablaAsignaciones(asignaciones), {
    titulo: TITULO,
    empresaNombre,
    descripcionFiltros,
  });

  descargarLibro(
    [{ nombre: "Asignaciones", hoja }],
    `AsignacionTurnos_${moment().format("YYYY-MM-DD")}`,
  );
};
